<!--
 * @Description: 
 * @Date: 2019-09-19 10:54:19
 -->
<template>
  <el-switch
    class="my-switch"
    :active-value="1"
    :inactive-value="0"
    active-icon-class="choose"
    inactive-icon-class="close"
    v-bind="$attrs"
    @change="change($event)"
  ></el-switch>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  watch: {},
  computed: {},
  methods: {
    change(val) {
      this.$emit('input', val);
    }
  },
  created() {},
  beforeDestroy() {}
};
</script>

<style lang="scss">
.my-switch {
  .el-switch__label {
    position: absolute;
    z-index: 11;
  }
  .el-switch__label--left::before {
    content: '能';
    width: 50%;
    height: 100%;
    margin: 0;
    color: #ffffff;
    display: block;
    transform: scale(0.65);
    padding: 0 4px;
  }
  .el-switch__label--right {
    right: 0;
  }
  .el-switch__label--right::before {
    content: '否';
    width: 50%;
    height: 100%;
    margin: 0;
    color: #ffffff;
    display: block;
    transform: scale(0.65);
    padding: 0 4px;
  }
}
</style>
<style scoped lang="scss">
.my-switch {
  user-select: none;
  transform: scale(1.6);
  margin-left: 12px;
}
</style>
